import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableUser = QueryHookResult<typeof useUsersQuery>[number];

export const useUsersQuery = createQueryHook(
  'shared.selectUser',
  () => ({
    coreUsersByOrganization: {
      __args: {
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
      },
    },
  }),
  {
    select: (data) => data?.coreUsersByOrganization?.entries ?? [],
  },
);

export const SelectUser = createEntityComboBox.locallySearched(
  'SelectUser',
  useUsersQuery,
  {
    formatLabel: (entity) =>
      [entity.firstName, entity.lastName].filter(Boolean).join(' '),
    formatSubLabel: (entity) =>
      [entity.email, entity.phoneNumber].filter(Boolean).join('・'),
  },
);
